import React from "react";
import { MessageCircle } from "lucide-react";
import { Logo } from "../Logo";
import { resellerWaLink, RESELLER_GENERIC_MSG } from "../../data/reseller";

export const ResellerCta = () => (
  <section className="max-w-[1300px] mx-auto px-5 md:px-6 py-16">
    <div className="relative overflow-hidden rounded-3xl border border-brand-2/30 bg-surface/70 p-8 md:p-14 flex flex-col lg:flex-row items-center gap-10">
      <div className="absolute -right-24 -bottom-24 w-96 h-96 rounded-full bg-brand-3/15 blur-[120px] pointer-events-none" />
      <Logo className="h-28 md:h-36 shrink-0" testId="reseller-cta-logo" />
      <div className="relative flex-1 text-center lg:text-left">
        <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight">Pronto para começar a lucrar?</h2>
        <p className="mt-3 text-silver/80 max-w-xl">Fale agora com a nossa equipe e receba seu painel de revenda ainda hoje.</p>
      </div>
      <a
        href={resellerWaLink(RESELLER_GENERIC_MSG)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="reseller-final-cta"
        className="relative inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-gradient text-white font-bold shadow-xl shadow-brand/30 hover:brightness-110 transition"
      >
        <MessageCircle className="w-5 h-5" /> Falar no WhatsApp
      </a>
    </div>
  </section>
);
